import { observable, action } from 'mobx';
import {WeaForm} from 'comsMobx';
import * as API from '../apis/trainrecord';
import * as Util from '../util/index';
import {WeaTableNew} from 'comsMobx';
import {i18n} from '../public/i18n';
const {TableStore} = WeaTableNew;

export class HrmTrainRecord {
  title = i18n.module.trainRecord;
  tabDatas = [
    {title:'培训记录',key:"1"},
    {title:'培训安排',key:"2"}
  ];

  @observable form = new WeaForm();
  @observable table = new TableStore();
  @observable condition=[];
  @observable showSearchAd=false;
  @observable searchParamsAd={};
  @observable tabkey = '1';

  @action
  getData(params = {}) {
    this.getSearchCondition();
    this.getSearchList();
  }

  getSearchCondition(params = {}) {
    if (this.tabkey) params.tabkey = this.tabkey;
    API.getSearchCondition(params).then((data) => {
        this.condition = data.condition;
        this.form.initFormFields(data.condition);
    });
  }

  doSearch(){
    const formParams = this.form.getFormParams();
    formParams.search="search";
    this.getSearchList(formParams);
  }

  getSearchList(params = {}) {
    if (this.tabkey) params.tabkey = this.tabkey;
    API.getSearchList(params).then((data) => {
        this.table.getDatas(data.sessionkey,1);
    });
  }

  changeTab(key) {
    this.tabkey = key;
    this.form = new WeaForm();
    this.setShowSearchAd(false);
    this.getData();
  }
  
  setShowSearchAd(bool) {
    this.showSearchAd = bool;
  }

  getFormParams() {
    return this.form.getFormParams();
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/stores/trainrecord.js